import { Container } from './styled';
import {
    LineChart,
    BarChart
} from './Types';

export function Charts(props) {
    
    const { type, data } = props;

    return (
        <Container>
            {(type === 'Line') && <LineChart data={data} />}
            {(type === 'Bar') && <BarChart data={data} />}
        </Container>
    )
};